module.exports = __webpack_public_path__ + "images/arrows-metallic-9f9eceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/slider-v1/images/arrows-metallic.png
// module id = 109
// module chunks = 2